import React from 'react'
import { arrayOf, shape, bool } from 'prop-types'

import showTimesPropTypes from '@/shape/show-time'
import ShowTime from './component/ShowTime'

import styles from './ShowTimes.module.scss'
import classNames from 'classnames'

const ShowTimes = ({ showTimes, layoutV2 }) => {
  return (
    <>
      {showTimes && (
        <ul
          className={classNames(
            styles.TimesList,
            layoutV2 && styles.TimesListV2
          )}
        >
          {showTimes.map((showTime, i) => (
            <ShowTime
              nextShowing={showTime.nextShowing}
              location={showTime.location}
              distance={showTime.distance}
              times={showTime.times}
              key={`ShowTime-${i}`}
              layoutV2={layoutV2}
            />
          ))}
        </ul>
      )}
    </>
  )
}

ShowTimes.propTypes = {
  showTimes: arrayOf(shape(showTimesPropTypes)),
  layoutV2: bool
}

export default ShowTimes
